import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { AbstractFeatureEntityState, AbstractFeatureUIModel } from '@y42/feature';

export class CatalogSettingsGitModel {
  constructor(model: CatalogStoreModel) {
    Object.assign(this, model);
  }
}

export class CatalogStoreModel extends Y42MetadataGitModel {
  constructor(model: CatalogStoreModel) {
    super(model);

    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
  }

  $name: string;
  $path: string;
  $level: number;
}

export type CatalogUIModel = AbstractFeatureUIModel & CatalogStoreModel;

export type CatalogState = AbstractFeatureEntityState<CatalogStoreModel>;
